var OCS = OCS || {};
OCS.UI = OCS.UI || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.EmbeddableStaticUrl = new Class({
    Extends: OCS.WxBriefing.Classes.EmbeddableUrl,
    class_name: 'EmbeddableStaticUrl',
    options: {
        update_interval_rate: 0,
    },
    update_product: function () {
        // Same as an embeddable url except with no update process.
    }
});